<template>
    <div class="pt-1 bg-white" :class="displaySidebar ? 'main-container-with-sidebar' : 'w-100'">
        <router-view :key="$route.path"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'MainContainer',
        props: ['displaySidebar']
    }
</script>
